import React from 'react';
import PropTypes from 'prop-types';

// Models
import ContractModel from 'models/Contract';
import PaymentBreakdownModel from 'models/PaymentBreakdown';
import Datalist from 'ui/DataList';
import Text from 'ui/Text';

export const PaymentSummary = ({ contract, payment }) => {
  const data = contract.contractPeriod
    ? [
        {
          id: 'paymentDescription',
          label: 'Payment description:',
          value: payment.paymentDescription,
        },
        {
          id: 'paymentStatus',
          label: 'Payment status:',
          value: (
            <Text id="paymentStatus" color={payment.statusColor}>
              • {payment.statusInPaymentSummary}
            </Text>
          ),
          break: true,
        },
        {
          id: 'contractNumber',
          label: 'Contract number:',
          value: '#' + contract.contractNumber,
        },
        {
          id: 'contractPeriod',
          label: 'Contract period:',
          value: contract.contractPeriod,
        },
        {
          id: 'paymentTerm',
          label: 'Payment term:',
          value: contract.paymentTerm,
        },
        {
          id: 'current-rate',
          label: 'Current rate:',
          value: contract.paymentRate,
        },
      ]
    : [
        {
          id: 'paymentDescription',
          label: 'Payment description:',
          value: payment.paymentDescription,
        },
        {
          id: 'paymentStatus',
          label: 'Payment status:',
          value: (
            <Text id="paymentStatus" color={payment.statusColor}>
              • {payment.statusInPaymentSummary}
            </Text>
          ),
          break: true,
        },
        {
          id: 'contractNumber',
          label: 'Contract number:',
          value: '#' + contract.contractNumber,
        },
        {
          id: 'paymentTerm',
          label: 'Payment term:',
          value: contract.paymentTerm,
        },
        {
          id: 'current-rate',
          label: 'Current rate:',
          value: contract.paymentRate,
        },
      ];
  return (
    <>
      <Datalist
        size="large"
        title={payment.createdAt}
        data={data}
        narrow={true}
      />
    </>
  );
};

PaymentSummary.propTypes = {
  contract: PropTypes.instanceOf(ContractModel),
  payment: PropTypes.instanceOf(PaymentBreakdownModel),
};

PaymentSummary.defaultProps = {
  contract: new ContractModel(),
  payment: new PaymentBreakdownModel(),
};

export default PaymentSummary;
